import React from 'react';
import { Link } from 'react-router-dom';

export default function OnTimeAdminPage() {
  return (
    <section className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">On Time</h2>
        <p className="mt-1 text-sm text-white/70">
          Create On Time-first organizations, restore owner-managed Profiles, and give On Time a clean entry path without disturbing Neo.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-cyan-300">Org creation</div>
          <h3 className="mt-2 text-lg font-semibold">Create an On Time organization</h3>
          <p className="mt-2 text-sm text-white/70">
            Opens the create-organization form with On Time preselected as the enabled app and preferred landing app.
          </p>
          <Link
            to="/super/orgs/new?app=ontime"
            className="mt-4 inline-flex rounded-full bg-cyan-600 px-4 py-2 text-sm font-medium text-white hover:bg-cyan-500"
          >
            Create On Time org
          </Link>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-cyan-300">Entry path</div>
          <h3 className="mt-2 text-lg font-semibold">Open On Time entry</h3>
          <p className="mt-2 text-sm text-white/70">
            Use the dedicated On Time entry path when you want to go straight into the On Time side without mixing it with Neo navigation.
          </p>
          <Link
            to="/ontime-login"
            className="mt-4 inline-flex rounded-full border border-cyan-400/40 px-4 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/10"
          >
            Open On Time entry
          </Link>
        </div>
      </div>
    </section>
  );
}
